var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-empty',{staticStyle:{"margin-top":"24px","margin-bottom":"0"},attrs:{"image":_vm.emptyImage},scopedSlots:_vm._u([{key:"description",fn:function(){return [_c('div',{staticStyle:{"color":"#666","margin-top":"16px"}},[_vm._v("暂无数据")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }